import React from 'react'

export const InvoiceStylesStyles: { [key: string]: React.CSSProperties } = {
    container: {
        paddingBottom: 20,
        paddingRight: 20,
        paddingLeft: 20,
        paddingTop: 20,
    },
    titleContainer: { display: 'inline-block', marginBottom: 15 },
    titleContent: {
        paddingTop: 7,
        display: 'flex',
        paddingLeft: 15,
        paddingBottom: 7,
        paddingRight: 15,
        borderRadius: 15,
        alignItems: 'center',
        backgroundColor: '#184287',
    },
    dot: {
        width: 7,
        height: 7,
        marginRight: 7,
        borderRadius: 7,
        backgroundColor: '#fff',
    },
    itemContainer: {
        display: 'flex',
        marginBottom: 10,
        justifyContent: 'space-between',
    },
    btnContainer: { display: 'flex', justifyContent: 'center' },
    btnHistory: {
        paddingTop: 12,
        paddingLeft: 20,
        borderRadius: 7,
        marginRight: 10,
        paddingRight: 20,
        cursor: 'pointer',
        paddingBottom: 12,
        backgroundColor: '#184287',
        boxShadow: '0px 10px 20px -10px #805DCA99',
    },
    btnInvoice: {
        paddingTop: 12,
        paddingLeft: 20,
        borderRadius: 7,
        paddingRight: 20,
        cursor: 'pointer',
        paddingBottom: 12,
        backgroundColor: '#2699D6',
    },
}
